module.exports = __webpack_public_path__ + "static/media/ba.1cb44d09.webp";